import { Component, OnInit, Signal } from '@angular/core';
import { ContentComponent } from '../../components/content/content.component';
import { BreadcrumbsComponent } from '../../common/breadcrumbs/breadcrumbs.component';
import { ReactiveFormsModule } from '@angular/forms';
import { PaymentForm } from './payment.form';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { PaymentCommonService } from '../../services/payment.common.service';
import { ValidationErrorsComponent } from '../../common/validation-errors/validation-errors.component';
import { CommonModule } from '@angular/common';
import { LabelComponent } from '../../common/label/label.component';
import { SessionService } from '../../services/ssession.service';
import { UserDetails } from '../../store/reducers/user-details.reducer';
import { selectUser } from '../../store/selectors/user-details.selectors';
import { loadUserDetails } from '../../store/actions/user-details.actions';

@Component({
  selector: 'app-payments-page',
  standalone: true,
  imports: [
    CommonModule,
    ContentComponent,
    BreadcrumbsComponent,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    LabelComponent,
    RouterModule
  ],
  providers: [PaymentForm],
  templateUrl: './payments-page.component.html'
})
export class PaymentsPageComponent implements OnInit {

  public paymentToken: string | undefined = this.route.snapshot.queryParams['payum_token'] || this.route.snapshot.queryParams['amp;payum_token'];

  public appId: string | undefined = this.route.snapshot.queryParams['appId'];

  public serviceType: string | undefined = this.route.snapshot.queryParams['serviceType'] || this.route.snapshot.queryParams['amp;serviceType'];

  public serviceTypeName: string | undefined = this.route.snapshot.queryParams['serviceTypeName'] || this.route.snapshot.queryParams['amp;serviceTypeName'];

  public authed: boolean = SessionService.Authed();

  public user: Signal<UserDetails | null> = this.store$.selectSignal(selectUser);

  constructor(
    private store$: Store,
    private route: ActivatedRoute,
    private router: Router,
    private paymentCommonService: PaymentCommonService,
    public form: PaymentForm
  ) {
  }

  public onPastDataFromPortal(): void {
    this.form?.readApplicantDataFromPortal(this.user());
  }

  public onPastDataFromLoginGov(): void {
    this.form?.readApplicantDataFromGovPl(SessionService.GetTokenData());
  }

  public submit(): void {
    if (this.form.valid) {
      this.paymentCommonService.goToPay(this.form.toWriteModel())
        .toPromise().then();
    } else {
      this.form.markAllAsTouched();
    }
  }

  public ngOnInit(): void {
    if (this.authed) {
      this.store$.dispatch(loadUserDetails());
    }
    switch (true) {
      case !!this.paymentToken && !!this.appId && !!this.serviceType: {
        this.router.navigateByUrl('/platnosci-online/' + this.paymentToken + '/' + this.appId + this.serviceType);
        break;
      }
      case !!this.paymentToken: {
        this.router.navigateByUrl('/platnosci-online/' + this.paymentToken);
        break;
      }
      case !!this.serviceType: {
        this.form.paymentCategories$.subscribe(() => {
          this.form.get('paymentCategory')?.setValue(this.serviceType);
          this.form.paymentCategoryChange(this.serviceType || '');
        });
        break;
      }
      case !!this.serviceTypeName: {
        this.form.paymentCategories$.subscribe(categories => {
          const v = categories.filter(v => v.name === this.serviceTypeName)?.at(0)?.id || '';
          this.form.get('paymentCategory')?.setValue(v);
          this.form.paymentCategoryChange(v);
        });
        break;
      }
      default: {
        // do nothing
      }
    }
  }
}
